import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { OTPTypes } from './OTP.model';
import { PDFViewerService } from '../../../features/connect/meetings/services/PDFViewer.service';

@Component({
  standalone: false,
  selector: 'app-one-time-password',
  templateUrl: './one-time-password.component.html'
})
export class OneTimePasswordComponent implements OnInit {
  @Input() meetingId: any;
  @Input() documentId: any;
  @Input() type: OTPTypes = OTPTypes.MOM;
  @Output() cancelPop: EventEmitter<boolean> = new EventEmitter();

  id: number;
  dataLoading = false;
  loading = false;
  passwordLabel = {
    password: null,
    isOtpNotFromSms: false
  };

  passwordCtr = new UntypedFormControl(null, Validators.required);

  constructor(
    public service: PDFViewerService,
    public translate: TranslateService
  ) { }

  ngOnInit() {
    if (this.documentId && this.meetingId) {
      this.type = OTPTypes.MOMDoc;
    }
    this.RequestOneTimePassword();
  }

  RequestOneTimePassword() {
    this.dataLoading = true;
    const id = this.documentId ? this.documentId : this.meetingId;
    this.service.RequestOneTimePassword(id, this.type).subscribe(
      result => {
        this.dataLoading = false;
        this.passwordLabel = result as any;
      },
      err => {
        this.dataLoading = false;
        console.error(err);
      }
    );
  }

  submit() {
    this.passwordCtr.markAsTouched();
    if (this.passwordCtr.valid) {
      this.loading = true;
      const data = {
        meetingId: this.meetingId,
        documentId: this.documentId,
        oneTimePassword: this.passwordCtr.value
      };
      this.service.SubmitMySignature(data, this.type).subscribe(
        response => {
          this.loading = false;
          Swal.fire({
            title: this.translate.instant('swalMsg.success'),
            text: this.translate.instant('swalMsg.sentsuccessfuly'),
            icon: 'success',
            confirmButtonText: this.translate.instant('swalMsg.ok')
          }).then((result) => {
            this.cancelPop.emit(true);
          });

        },
        error => {
          this.loading = false;
          Swal.fire({
            title: this.translate.instant('swalMsg.Failed'),
            text: (error.status == 406) ? this.translate.instant('voting.Invalid Password') : this.translate.instant('swalMsg.Failed'),
            icon: 'error',
            confirmButtonText: this.translate.instant('swalMsg.ok')
          });
        });
    }
  }
}
